<template>
  <div class="page form_simple adjust_width">

    <title_cat>Ajouter une catégorie</title_cat>

    <el-form label-position="left" label-width="190px" @submit.native.prevent="categorie_add">

      <el-form-item label="Titre de la catégorie">
        <el-input  type="text"  v-model="name" name="input"></el-input>
      </el-form-item>

      <button>Ajouter</button>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "produit_add_update",
  data() {
    return {
      name: '',
    }
  },
  beforeMount() {
    this.$nextTick(() => {
        document.querySelector('input[name=input]').focus()
    })
  },
  methods: {
    categorie_add() {
      if(this.name) {
        this.$http.post('/bo/boutique/categorie', { name: this.name }).then((r) => {
          console.log(r)
          if (r.status === 201) {
            this.$notify({
              title: 'Catégorie ajouté', offset: this.$notifyOffest, type: 'success'
            });
            this.$store.dispatch("boutique_bo/sync");
            this.$router.push({name: 'bo_produits_in_category', params: {categorie: this.name}})
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>